import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BadgeColorsEnum} from '../../../shared/interfaces/BadgeColorsEnum';
import {Select, Store} from '@ngxs/store';
import {
  RemoveWholesalerConnection,
  RunWholesalerIntegration,
  SetWholesalerConnectionActive,
} from '../../../shared/states/profile/profile.actions';
import {take, withLatestFrom} from 'rxjs/operators';
import {ProfileState} from '../../../shared/states/profile/profile.state';
import {Observable} from 'rxjs/internal/Observable';
import {WholesalerIntegrationStatusEnum} from '../../interfaces/WholesalerIntegrationStatusEnum';
import { IWholesalerConnection } from 'src/app/shared/interfaces/wholesaler-integration.interface';

@Component({
  selector: 'app-wholesaler-integration-table',
  templateUrl: './wholesaler-integration-table.component.html',
  styleUrls: ['./wholesaler-integration-table.component.scss'],
})
export class WholesalerIntegrationTableComponent {
  @Input() wholesalerIntegrationList: IWholesalerConnection[] = [];

  @Output() editWholesaler: EventEmitter<IWholesalerConnection> = new EventEmitter();

  BadgeColorsEnum = BadgeColorsEnum;
  WholesalerIntegrationStatusEnum = WholesalerIntegrationStatusEnum;

  currentWholesaler: IWholesalerConnection;

  showRemoveWholesalerDialog: boolean;

  @Select(ProfileState.loading) loading$: Observable<boolean>;
  @Select(ProfileState.success) success$: Observable<boolean>;

  constructor(
    private store: Store,
  ) {
  }

  runWholesalerIntegration(item: IWholesalerConnection): void {
    this.currentWholesaler = item;
    this.store.dispatch(new RunWholesalerIntegration(item));
  }

  setActivityStatus(item: IWholesalerConnection, setActive: boolean): void {
    this.currentWholesaler = item;
    this.store.dispatch(new SetWholesalerConnectionActive(item.id, setActive));
  }

  openRemoveWholesalerDialog(item: IWholesalerConnection): void {
    this.currentWholesaler = item;
    this.showRemoveWholesalerDialog = true;
  }

  closeRemoveWholesalerDialog(): void {
    this.showRemoveWholesalerDialog = false;
  }

  removeWholesaler(): void {
    this.store.dispatch(new RemoveWholesalerConnection(this.currentWholesaler?.id))
      .pipe(take(1), withLatestFrom(this.success$))
      .subscribe(([_, success]) => {
        if (success) {
          this.closeRemoveWholesalerDialog();
        }
      });
  }
}
